export default __webpack_public_path__ + "static/media/lhs.0562cf30.png";